import React from "react";
import { FaSyncAlt } from "react-icons/fa";
import ProductConsumentCard from "./ProductConsumentCard";
import { DayFilterButton } from "./FilterButtons";

function ConsumptionSection({
  dashboardType,
  activeConsumption,
  handleClickConsumption,
  consumption,
  performance,
  warn,
  isLoading,
  isFetching,
  canSeeBillDetails,
  incomes,
  salesQuantity,
  onRefresh,
  isRefreshing = false,
  // Dönem butonlarının altına konan ek kontrol (bayide kapsam seçicisi).
  belowFilters = null,
}) {
  return (
    <div className="w-full lg:w-[40%] bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-200 flex flex-col">
      {/* Header — diğer sayfalardaki PageHeader diliyle aynı */}
      <div className="bg-gray-50 p-3 sm:p-4 border-b border-gray-200 shrink-0">
        <div className="flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
          <div className="flex items-center gap-3">
            {/* Yenile — sahte yükleme tetikler (eski tüketim türü modalının yerine).
                onRefresh verilmeyen kullanımda (dealer) pasif ikon çipi olur. */}
            {onRefresh ? (
              <button
                type="button"
                onClick={onRefresh}
                disabled={isRefreshing || isLoading}
                title="Yenile"
                aria-label="Yenile"
                className="p-1.5 sm:p-2 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg sm:rounded-xl shadow-sm border border-blue-100 hover:from-blue-100 hover:to-indigo-100 transition-colors disabled:opacity-60"
              >
                <FaSyncAlt className={`w-5 h-5 sm:w-6 sm:h-6 text-blue-600 ${isRefreshing ? "animate-spin" : ""}`} />
              </button>
            ) : (
              <div className="p-1.5 sm:p-2 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg sm:rounded-xl shadow-sm border border-blue-100">
                <FaSyncAlt className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
              </div>
            )}
            <div>
              <h2 className="text-base sm:text-xl font-bold text-gray-900">Tüketimler</h2>
              <p className="text-xs sm:text-sm text-gray-500 mt-0.5">Ürün tüketim analizi</p>
            </div>
          </div>

          <div className="flex flex-col gap-2 w-full sm:w-auto sm:items-end">
            <div className="flex flex-wrap gap-2">
              <DayFilterButton
                active={activeConsumption}
                handleClick={handleClickConsumption}
                isLoading={isLoading || isFetching}
                button="px-2 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300"
              />
            </div>
            {belowFilters}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 min-h-0 overflow-hidden py-2 sm:py-3 px-3 sm:px-4">
        <ProductConsumentCard
          dashboardType={dashboardType}
          consumption={consumption}
          performance={performance}
          warn={warn}
          dashboardConsumentIsLoading={isLoading}
          dashboardConsumentIsFetching={isFetching}
          canSeeBillDetails={canSeeBillDetails}
          incomes={incomes}
          salesQuantity={salesQuantity}
          activeConsumption={activeConsumption}
        />
      </div>
    </div>
  );
}

export default React.memo(ConsumptionSection);
